import { DatadogGraphsApiResponse } from "@app/performance/ui-statistics/types";
import ServiceBase from "@app/shared/serviceBase";

export default class DatadogDashboardService extends ServiceBase {
  public async getGraphsForClient(timeframe: string, category: number): Promise<DatadogGraphsApiResponse[]> {
    return await this.makeGet("datadogDashboard/getGraphsForClient", { category, timeframe });
  }
}